import { render, staticRenderFns } from "./wikiSelect.vue?vue&type=template&id=a5d4fb54"
import script from "./wikiSelect.vue?vue&type=script&lang=js"
export * from "./wikiSelect.vue?vue&type=script&lang=js"
import style0 from "./wikiSelect.vue?vue&type=style&index=0&id=a5d4fb54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports